import React, { useState, useEffect } from 'react'
// import ReactDOM from 'react-dom'
import { getEnv } from 'configurations'
import AWS from 'aws-sdk'
import mapboxgl from 'mapbox-gl'

import DeckGL from '@deck.gl/react'
import ReactMapGL from 'react-map-gl'
import { useDispatch, useSelector } from 'react-redux'
import { EditableGeoJsonLayer } from '@nebula.gl/layers'
import { PathStyleExtension, DataFilterExtension } from '@deck.gl/extensions'
import { ViewMode, ModifyMode } from '@nebula.gl/edit-modes'

// import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'
// import CircularProgress from '@material-ui/core/CircularProgress'
// import Modal from '@material-ui/core/Modal'
import Tooltip from '@material-ui/core/Tooltip'
// import TextField from '@material-ui/core/TextField'
import Divider from '@material-ui/core/Divider'

import { Breadcrumb } from 'antd'
import LogoTycho from 'assets/logo_tycho.png'
import RedMarker from 'assets/red_marker.png'
import DrawIcon from 'assets/pencil.png'
import FileIcon from 'assets/folder.png'
import CRSIcon from 'assets/crs.png'

import { setSideBarInfo } from 'store/global/map/sideBarInfo'
import { setBasemapStyleStore } from 'store/global/map/basemapStyleInfo'

import DrawingTools from './DrawingTools/DrawingMenu'
import ClickMenu from './DrawingTools/ClickMenu'
import EditMenu from './DrawingTools/EditMenu'
import FilesMenu from './DrawingTools/DrawingFiles/FilesMenu'
import CRSMenu from './DrawingTools/CoordinateSystem/CoordinateSystem'
import PropertiesMenu from './DrawingTools/DrawingProperties/DrawingProperties'
import Styles from './SelectStyles/SelectStyles'

import RpcApiClient from 'datasources/RpcApiClient'
import BitMapLayers from '../Map/layers/BitMapLayers.js'
import LayersApi from '../Map/layers/LayersApi.js'

import './geomap.css'

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default

const useStyles = makeStyles((theme) => ({
  circle: {
    color: '#a65e44',
  },
}))

function GeoMap(props) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const MAPBOX_ACCESS_TOKEN = getEnv('REACT_APP_MAPBOX_TOKEN')
  const [initialViewState, setInitialViewState] = useState({
    latitude: 0,
    longitude: 0,
    bearing: 0,
    pitch: 0,
    zoom: 1,
  })

  const authData = useSelector((state) => state.auth.authData)
  const userCompany = useSelector((state) => state.companyState.id)
  const viewStateData = useSelector((state) => state.viewState.viewStateData)
  const basemapStyle = useSelector((state) => state.basemapStyle.basemapStyleData)
  const basemapName = useSelector((state) => state.basemapStyle.basemapStyleName)
  const layersInfo = useSelector((state) => state.layersInfo)

  const refDeckgl = React.createRef()
  const refMap = React.createRef()

  const [sidebarData, setSidebarData] = useState([])
  const [sidebarBandera, setSidebarBandera] = useState(false)
  const [clientPlan, setClientPlan] = useState('')
  const [layerDisplayData, setLayerDisplayData] = useState([])
  const [layerBitMap, setLayerBitMap] = useState([])
  const [layerHelper, setLayerHelper] = useState([])

  const [styles, setStyles] = useState('mapbox://styles/rmstycho/cl2rrcjn5003c15lbbt5urwm2')

  const [draw, setDraw] = useState(false)
  const [files, setFiles] = useState(false)
  const [CRS, setCRS] = useState(false)
  const [crossPointer, setCrossPointer] = useState(false)

  const [mode, setMode] = useState(() => ViewMode)
  const [style, setStyle] = useState({
    lineColor: [40, 40, 40],
    fillColor: [120, 120, 120, 125],
    tentativeLineColor: [236, 236, 236],
    tentativeFillColor: [255, 255, 255, 80],
    pointType: 'circle',
    url: null,
  })
  const [selectedFeatureIndexes, setSelectedFeatureIndexes] = useState([0])
  const [features, setFeatures] = useState({
    type: 'FeatureCollection',
    features: [],
  })

  const [clickInfo, setClickInfo] = useState({
    name: '',
    description: '',
    type: '',
    coordinates: [[0, 0]],
  })

  const [toggler, setToggler] = useState({ visibility: 'hidden', x: -100, y: -100 })
  const [editClick, setEditClick] = useState({ visibility: 'hidden', x: -100, y: -100 })
  const [rightClick, setRightClick] = useState({ visibility: 'hidden', x: -100, y: -100 })
  const [propertiesClick, setPropertiesClick] = useState({ visibility: 'hidden', x: -100, y: -100 })
  const [selectedGeometry, setSelectedGeometry] = useState()
  const [colorChange, setColorChange] = useState(0)
  const [activeProject, setActiveProject] = useState('Project A')
  const [CRSID, setCRSID] = useState('DD')
  const [fileList, setFileList] = useState([])
  const [units, setUnits] = useState('km2')

  const hideMenu = { visibility: 'hidden', x: -100, y: -100 }

  const drawLayer = new EditableGeoJsonLayer({
    id: 'draw-layer-geocrator',
    data: features,
    mode: mode,
    selectedFeatureIndexes,
    //edit custom points
    getEditHandlePointColor: [255, 0, 0, 200],
    getEditHandlePointOutlineColor: (d) => (style.tentativeLineColor ? style.tentativeLineColor : [236, 236, 236]),
    editHandlePointStrokeWidth: 3,
    //editHandlePointRadiusMaxPixels:8,
    //editHandlePointRadiusMinPixels:4,
    //editHandlePointRadiusScale:1,
    //editHandlePointRadiusUnits: "pixels",
    //editHandlePointStrokeWidth: 2,
    //editHandleType: "point",
    //editHandlePointRadiusScale: 2,
    //getEditHandlePointRadius:5,

    //customize tentative feature style
    getTentativeLineColor: (d) => (style.tentativeLineColor ? style.tentativeLineColor : [255, 255, 255, 80]),
    getTentativeFillColor: (d) => (style.tentativeFillColor ? style.tentativeFillColor : [236, 236, 236]),
    getTentativeLineWidth: 3,

    //geojson styles
    // getFillColor: (d) => d.properties.polygonFillColor ? d.properties.polygonFillColor : [120, 120, 120, 125],
    // getLineColor: (d) =>  [40, 40, 40],
    // getLineWidth: 3,
    getRadius: 5,
    // pointType: 'circle',
    pointRadiusMinPixels: 5,
    pointRadiusScale: 1,
    _subLayerProps: {
      geojson: {
        getFillColor: (d) => (d.properties.fillColor ? d.properties.fillColor : [51, 51, 51, 125]),
        getLineColor: (d) => (d.properties.lineColor ? d.properties.lineColor : [51, 51, 51]),
        getLineWidth: (d) => (d.properties['stroke-width'] ? d.properties['stroke-width'] : 3),
        pointType: 'circle',
        getFilterValue: (d) => d.properties.show,
        filterRange: [1, 1],
        extensions: [new DataFilterExtension({ filterSize: 1 }), new PathStyleExtension({ dash: true })],
        getDashArray: (d) => (d.properties.dottedLine ? d.properties.dottedLine : [3, 2]),
        dashJustified: true,
        updateTriggers: {
          getFillColor: colorChange,
          getLineColor: colorChange,
          getLineWidth: colorChange,
          getFilterValue: colorChange,
          data: colorChange,
          getDashArray: colorChange,
        },
      },
      guides: {
        pointType: style.pointType ? style.pointType : 'circle',
        getIcon: (d) => ({
          url: style.url ? style.url : RedMarker,
          width: 128,
          height: 128,
          anchorY: 128,
        }),
        iconSizeMaxPixels: 25,
        iconSizeMinPixels: 25,
        iconSizeUnits: 'pixels',
        getDashArray: [3, 2],
        dashJustified: true,
        extensions: [new PathStyleExtension({ dash: true })],
      },
    },
    // onClick:(e)=>{findClick(e.object.geometry)},
    onHover: (info) => {
      info.object = { html: false }
    },
    onEdit: (event) => {
      handleDraw(event)
    },
  })

  const handleDraw = (event) => {
    // console.log(event)
    const { editType, updatedData, editContext } = event
    setFeatures(updatedData)
    if (editType === 'addFeature') {
      const data = updatedData
      data.features[data.features.length - 1].properties.id = activeProject
      data.features[data.features.length - 1].properties.show = 1
      mode.name === 'DrawPolygonMode' || mode.name === 'A' ? document.getElementById('Polygon').click() : null
      mode.name === 'DrawLineStringMode' || mode.name === 'h' ? document.getElementById('Line').click() : null
      //VIEWMODE = n
      //ModifyMode = A
    }
    if (editType === 'finishMovePosition' || editType === 'addPosition') {
      const geom = updatedData.features[editContext.featureIndexes[0]]
      setClickInfo({
        name: geom.properties.name ? geom.properties.name : '',
        description: geom.properties.description ? geom.properties.description : '',
        type: geom.geometry.type,
        coordinates:
          geom.geometry.type === 'Polygon'
            ? geom.geometry.coordinates[0]
            : geom.geometry.type === 'Point'
            ? [geom.geometry.coordinates]
            : geom.geometry.coordinates,
      })
    }
  }

  const handleTooltip = (info) => {
    // setHover(info)
    // console.log(info)
    if (info?.object && info.object.html !== false) {
      return {
        html: `<div>${info.object.html}</div>`,
        style: {
          backgroundColor: '#fafcff',
          color: '#000000',
          fontSize: '14px',
          marginLeft: '20px',
          borderLeftStyle: 'solid',
          borderLeftColor: '#d4d9df',
          borderLeftWidth: '6px',
          borderRadius: '5px',
        },
      }
    }
  }

  const handleMenu = (key) => {
    if (key === 'files') {
      setDraw(false)
      files ? setFiles(false) : setFiles(true)
      setCRS(false)
    }
    if (key === 'draw') {
      draw ? setDraw(false) : setDraw(true)
      setFiles(false)
      setCRS(false)
    }
    if (key === 'crs') {
      setDraw(false)
      setFiles(false)
      CRS ? setCRS(false) : setCRS(true)
    }
  }

  const handleViewState = (data) => {
    props.setViewState({
      longitude: data.longitude,
      latitude: data.latitude,
      zoom: data.zoom,
      pitch: 0,
      bearing: 0,
    })
  }

  const getDataStructure = async (datastructure) => {
    const response = await RpcApiClient.getDataStructure(authData.jwtToken, datastructure)
    const data = await response

    dispatch(setSideBarInfo(data.data.data))
    let currentSidebarJSON = JSON.parse(JSON.stringify(data.data.data))
    let currentSidebar = [...currentSidebarJSON]
    setSidebarData(currentSidebar)
    setSidebarBandera(true)
  }

  const getFiles = async () => {
    try {
      const body = {
        company: userCompany,
        plan: '',
        country: 'Mexico',
        files: [],
      }
      const body2 = {
        company: userCompany,
        client_email: authData.email,
        plan: '',
        country: 'Mexico',
        files: [],
      }
      const response = await RpcApiClient.getFiles(authData.jwtToken, body)
      const response2 = await RpcApiClient.getFiles(authData.jwtToken, body2)
      response2.data.body.map((file) => response.data.body.push(file))
      setFileList(
        response.data.body.map((data, i) => {
          return data
        }),
      )
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    document.addEventListener('contextmenu', (event) => {
      event.preventDefault()
    })
    if ('plan' in props.countrySelected) {
      setClientPlan(props.countrySelected.plan)
    } else {
      setClientPlan('basic')
    }

    if ('datastructure' in props.countrySelected) {
      // console.log("Hay estructura de datos")
      const datastructure = props.countrySelected.datastructure
      getDataStructure(datastructure)
    }

    if (viewStateData != initialViewState && !props.viewState) {
      let currentInitialViewStateStoredJSON = JSON.parse(JSON.stringify(viewStateData))
      let currentInitialViewState = { ...currentInitialViewStateStoredJSON }
      setInitialViewState((initialViewState) => currentInitialViewState)
    }
    if (props.viewState) {
      setInitialViewState(props.viewState)
    }
    setLayerBitMap(BitMapLayers(true))
    if (layersInfo.data.length) setLayerDisplayData(LayersApi(layersInfo.data))
    if (props.features.features.length) setFeatures(props.features)
    if (basemapStyle.trim() !== '') {
      setStyles(basemapStyle)
      if (basemapName === 'satelite') bitmapToggle(true)
      if (basemapName === 'dark') bitmapToggle(false)
      if (basemapName === 'light') bitmapToggle(false)
      if (basemapName === 'streets') bitmapToggle(false)
      if (basemapName === 'outdoors') bitmapToggle(false)
      if (basemapName === 'slope') bitmapToggle(false)
      if (basemapName === 'wind') bitmapToggle(false)
      if (basemapName === 'solar') bitmapToggle(false)
    }
    // const body2 = {
    //   company: 'internal',
    //   client_email: 'david.sanchez@tycho.solutions',
    //   plan: '',
    //   country: 'Mexico',
    //   files: ['geojson_final.geojson'],
    // }

    // const body3 = {
    //   company: 'internal',
    //   client_email: 'david.sanchez@tycho.solutions',
    //   plan: '',
    //   country: 'Mexico',
    //   files: ['geojson_final.geojson', 'Geojson_prueba.geojson'],
    // }

    // getFiles()
    // RpcApiClient.getFileTree(authData.jwtToken,body2).then(val=>console.log(val.data.body))
    // RpcApiClient.getFileContent(authData.jwtToken,body3).then(val=>console.log(val.data.body))
  }, [])

  useEffect(() => {
    props.setFeatures(features)
  }, [features])

  useEffect(() => {
    dispatch(setBasemapStyleStore(styles))
  }, [styles])

  const bitmapToggle = (bool) => {
    setLayerBitMap(BitMapLayers(bool))
  }

  const Selected = (info, event) => {
    // console.log(info.object)
    if (event.rightButton) {
      if (info?.object && !crossPointer && info?.object.type) {
        setToggler(hideMenu)
        setEditClick(hideMenu)
        setPropertiesClick(hideMenu)
        setMode(() => ViewMode)
        setRightClick({ visibility: 'visible', x: info.x, y: info.y })
        setSelectedGeometry(info.object)
        // printData(info.object.geometry)
      }
    } else {
      //CLICK IZQUIERDO
      setPropertiesClick(hideMenu)
      if (
        info?.object &&
        info?.object.properties &&
        !crossPointer &&
        !info?.object.properties.guideType &&
        !info.object.html
      ) {
        if (mode.name === 'ModifyMode' || mode.name === 'A') {
          toggleGeometry(info.object)
          setSelectedGeometry(info.object)
          printData(info.object)
        } else {
          // console.log(info)
          setEditClick(hideMenu)
          setRightClick(hideMenu)
          setToggler({ visibility: 'visible', x: info.x, y: info.y })
          setSelectedGeometry(info.object)
          printData(info.object)
        }
      } else if (!info?.object) {
        setSelectedGeometry()
        setRightClick(hideMenu)
        setToggler(hideMenu)
        setEditClick(hideMenu)
        setPropertiesClick(hideMenu)
        selectedGeometry !== undefined || files ? setMode(() => ViewMode) : null
        // setMode(() => ViewMode)
      }
    }

    // if (!info?.object) setToggler({ display: 'none', x: -100, y: -100 })
  }

  const findGeometry = (geom) => {
    setToggler(hideMenu)
    setEditClick({ visibility: 'visible', x: -100, y: -100 })
    setPropertiesClick(hideMenu)
    setRightClick(hideMenu)
    // printData(selectedGeometry.geometry)
    printData(selectedGeometry)
    setMode(() => ModifyMode)
    features.features.map((val, i) => {
      if (val.geometry === selectedGeometry.geometry) {
        setSelectedFeatureIndexes([i])
      }
    })
  }

  const toggleGeometry = (geom) => {
    // printData(geom.geometry)
    printData(geom)
    features.features.map((val, i) => {
      if (val.geometry === geom.geometry) {
        setSelectedFeatureIndexes([i])
      }
    })
  }

  const moveGeometry = (project) => {
    // console.log(project)
    const updatedFeatures = features.features.map((val, i) => {
      if (val.geometry === selectedGeometry.geometry) {
        //setSelectedFeatureIndexes([i])
        val.properties.id = project.projectName
        return val
      }
      return val
    })
    setFeatures({
      type: 'FeatureCollection',
      features: updatedFeatures,
    })
  }

  const printData = (object) => {
    const { geometry, properties } = object
    setClickInfo({
      name: properties.name ? properties.name : '',
      description: properties.description ? properties.description : '',
      type: geometry.type,
      coordinates:
        geometry.type === 'Polygon'
          ? geometry.coordinates[0]
          : geometry.type === 'Point'
          ? [geometry.coordinates]
          : geometry.coordinates,
    })
  }

  const changeGeometry = (color, opacity, colorCode) => {
    const { r, g, b } = color
    const update = features
    update.features.map((val, i) => {
      if (val.geometry === selectedGeometry.geometry) {
        val.properties = {
          id: val.properties.id ? val.properties.id : null,
          show: val.properties.show ? val.properties.show : 1,
          name: val.properties.name ? val.properties.name : null,
          description: val.properties.description ? val.properties.description : null,
          colorCode: colorCode,
          fillColor: [r, g, b, opacity * 2.55],
          'marker-color': colorCode.hex,
          lineColor: [r - 40, g - 40, b - 40],
          opacity: opacity / 100,
        }
      }
    })
    setColorChange(Math.random())
    setFeatures(update)
  }

  const changeGeometryLine = (color, opacity, width, colorCode, line) => {
    const { r, g, b } = color
    const update = features
    update.features.map((val, i) => {
      if (val.geometry === selectedGeometry.geometry) {
        val.properties = {
          id: val.properties.id ? val.properties.id : null,
          show: val.properties.show ? val.properties.show : 1,
          name: val.properties.name ? val.properties.name : null,
          description: val.properties.description ? val.properties.description : null,
          colorCode: colorCode,
          lineColor: [r, g, b, opacity * 2.55],
          stroke: colorCode.hex,
          opacity: opacity / 100,
          'stroke-opacity': opacity / 100,
          'stroke-width': width,
          dottedLine: line ? [3, 2] : [0, 0],
        }
      }
    })
    setColorChange(Math.random())
    setFeatures(update)
  }

  const changeGeometryPolygon = (
    areaColor,
    opacity,
    borderOpacity,
    width,
    borderColor,
    colorCode,
    colorBorder,
    line,
  ) => {
    const { r, g, b } = areaColor
    const update = features
    update.features.map((val, i) => {
      if (val.geometry === selectedGeometry.geometry) {
        val.properties = {
          id: val.properties.id ? val.properties.id : null,
          show: val.properties.show ? val.properties.show : 1,
          name: val.properties.name ? val.properties.name : null,
          description: val.properties.description ? val.properties.description : null,
          colorCode: colorCode,
          colorCodeB: colorBorder,
          fillColor: [r, g, b, opacity * 2.55],
          fill: colorCode.hex,
          lineColor: [borderColor.r, borderColor.g, borderColor.b, borderOpacity * 2.55],
          stroke: colorBorder.hex,
          opacity: opacity / 100,
          'fill-opacity': opacity / 100,
          'stroke-opacity': borderOpacity / 100,
          'stroke-width': width,
          dottedLine: line ? [3, 2] : [0, 0],
        }
      }
    })
    setColorChange(Math.random())
    setFeatures(update)
    // console.log(features)
  }

  const deleteGeometry = () => {
    const filtro = features.features.filter((val) => val.geometry !== selectedGeometry.geometry)
    setFeatures({
      type: 'FeatureCollection',
      features: filtro,
    })
    setSelectedGeometry()
    setRightClick(hideMenu)
  }

  const propertiesGeometry = () => {
    setPropertiesClick({ visibility: 'visible', x: rightClick.x, y: rightClick.y })
    setRightClick(hideMenu)
    setEditClick(hideMenu)
    setToggler(hideMenu)
  }

  const close = () => {
    setToggler(hideMenu)
    setEditClick(hideMenu)
    setPropertiesClick(hideMenu)
    setSelectedGeometry()
  }

  if (Object.keys(props.countrySelected || {}).length === 0) {
    return <div> Please select a country</div>
  }

  //   if (loadingFlag && sidebarBandera) {
  return (
    <div style={{ height: '100%' }}>
      {/*<ConfirmClose editing={true} />*/}
      <Breadcrumb className="map-title">
        <Breadcrumb.Item>Scope</Breadcrumb.Item>
        <Breadcrumb.Item>{props.countrySelected.country}</Breadcrumb.Item>
      </Breadcrumb>

      <div className="map-container">
        <div
          style={{
            overflow: 'hidden',
            height: '100%',
            width: '100%',
          }}
        >
          <div>
            <div>
              <div
                className="on-click"
                style={{
                  visibility: `${toggler.visibility}`,
                  left: toggler.x,
                  top: toggler.y,
                  // top: '10px',
                  // right: '10px',
                  zIndex: '3',
                  marginBottom: '50px',
                  pointerEvents: toggler.visibility === 'hidden' ? 'none' : 'auto',
                  opacity: toggler.visibility === 'hidden' ? '0' : '1',
                }}
              >
                <ClickMenu clickInfo={clickInfo} units={units} close={close} />
              </div>

              <div
                className="on-click"
                style={{
                  visibility: `${editClick.visibility}`,
                  top: '10px',
                  right: '10px',
                  zIndex: '3',
                  marginBottom: '50px',
                  width: '293px',
                  pointerEvents: editClick.visibility === 'hidden' ? 'none' : 'auto',
                  opacity: editClick.visibility === 'hidden' ? '0' : '1',
                }}
              >
                <EditMenu
                  CRSID={CRSID}
                  clickInfo={clickInfo}
                  features={features}
                  setFeatures={setFeatures}
                  selectedGeometry={selectedGeometry}
                  setSelectedGeometry={setSelectedGeometry}
                  setToggler={setEditClick}
                  setMode={setMode}
                  editClick={editClick}
                  layerHelper={layerHelper}
                  setLayerHelper={setLayerHelper}
                  units={units}
                  setUnits={setUnits}
                  close={close}
                />
              </div>

              <div
                className="on-click"
                style={{
                  visibility: `${rightClick.visibility}`,
                  left: rightClick.x + 20,
                  top: rightClick.y - 45,
                  zIndex: '2',
                  width: '150px',
                  pointerEvents: rightClick.visibility === 'hidden' ? 'none' : 'auto',
                  opacity: rightClick.visibility === 'hidden' ? '0' : '1',
                }}
              >
                <button className="gm-options-btn" onClick={() => findGeometry()}>
                  <label className="gm-options-lbl">Edit Geometry</label>
                </button>
                <Divider style={{ width: '95%', margin: 'auto' }} />
                <button className="gm-options-btn" onClick={() => propertiesGeometry()}>
                  <label className="gm-options-lbl">Styles</label>
                </button>
                <Divider style={{ width: '95%', margin: 'auto' }} />
                <button className="gm-options-btn" onClick={() => deleteGeometry()}>
                  <label className="gm-options-lbl">Delete</label>
                </button>
              </div>

              <div className="gm-sidebar">
                <Tooltip title="Files" placement="right" arrow>
                  <button
                    className="gm-sidebar-btn"
                    style={!files ? { background: '' } : { background: '#01579b' }}
                    onClick={() => handleMenu('files')}
                  >
                    <img src={FileIcon} className="gm-sidebar-icons" />{' '}
                  </button>
                </Tooltip>
                <Tooltip title="Create Geometry" placement="right" arrow>
                  <button
                    className="gm-sidebar-btn"
                    style={!draw ? { background: '' } : { background: '#01579b' }}
                    onClick={() => handleMenu('draw')}
                  >
                    <img src={DrawIcon} className="gm-sidebar-icons" />{' '}
                  </button>
                </Tooltip>
                <Tooltip title="Coordinate System" placement="right" arrow>
                  <button
                    className="gm-sidebar-btn"
                    style={!CRS ? { background: '' } : { background: '#01579b' }}
                    onClick={() => handleMenu('crs')}
                  >
                    <img src={CRSIcon} className="gm-sidebar-icons" />{' '}
                  </button>
                </Tooltip>
              </div>

              <DrawingTools
                draw={draw}
                setMode={setMode}
                setCrossPointer={setCrossPointer}
                setSelectedGeometry={setSelectedGeometry}
              />

              <PropertiesMenu
                propertiesClick={propertiesClick}
                setPropertiesClick={setPropertiesClick}
                setSelectedGeometry={setSelectedGeometry}
                geometry={selectedGeometry}
                changeGeometry={changeGeometry}
                changeGeometryLine={changeGeometryLine}
                changeGeometryPolygon={changeGeometryPolygon}
              />

              <FilesMenu
                files={files}
                setFiles={setFiles}
                features={features}
                setFeatures={setFeatures}
                setActiveProject={setActiveProject}
                activeProject={activeProject}
                setColorChange={setColorChange}
                // fileList={fileList}
                // setFileList={setFileList}
                setInitialViewState={setInitialViewState}
                selectedGeometry={selectedGeometry}
                setSelectedGeometry={setSelectedGeometry}
                findGeometry={findGeometry}
                moveGeometry={moveGeometry}
                propertiesGeometry={propertiesGeometry}
                deleteGeometry={deleteGeometry}
                setMode={setMode}
                close={close}
              />

              <CRSMenu CRS={CRS} setCRS={setCRS} CRSID={CRSID} setCRSID={setCRSID} />

              <Styles
                setStyles={setStyles}
                bitmapToggle={bitmapToggle}
                rasters={{
                  solar: props.countrySelected.rasters.solar,
                  wind: props.countrySelected.rasters.wind,
                  slope: props.countrySelected.rasters.slope ? props.countrySelected.rasters.slope : null,
                }}
                country={props.countrySelected.map_location.country}
              />

              <DeckGL
                ref={refDeckgl}
                initialViewState={initialViewState}
                onDragEnd={(e) => handleViewState(e.viewport)}
                useDevicePixels={false}
                pickingRadius={5}
                controller={{ doubleClickZoom: false, dragRotate: false }}
                layers={[layerBitMap, layerHelper, layerDisplayData, drawLayer]}
                getTooltip={handleTooltip}
                getCursor={({ isHovering, isDragging }) =>
                  isHovering ? 'pointer' : crossPointer ? 'crosshair' : isDragging ? 'grabbing' : 'grab'
                }
                onClick={Selected}
                width="100%"
                height="100%"
                style={{ overflow: 'hidden' }}
              >
                <ReactMapGL
                  ref={refMap}
                  preserveDrawingBuffer={true}
                  mapboxApiAccessToken={MAPBOX_ACCESS_TOKEN}
                  mapStyle={styles}
                  preventStyleDiffing={true}
                />
              </DeckGL>
              <img src={LogoTycho} className="logo-tycho" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
  //   } else {
  //     return (
  //       <div className="main-container" style={{ overflow: 'hidden', backgroundColor: '#f0f2f5' }}>
  //         <div style={{ margin: 'auto', backgroundColor: '#f0f2f5' }}>
  //           <div
  //             style={{ width: '10%', left: '50%', marginTop: '25%', position: 'relative', backgroundColor: '#f0f2f5' }}
  //           >
  //             <CircularProgress className={classes.circle} />
  //             <h3 className="load-label">Loading map...</h3>
  //           </div>
  //         </div>
  //       </div>
  //     )
  //   }
}
export default GeoMap
